import React from 'react'
import Screen from './Screen'
import { useRouter } from 'react-router5'
import invariant from 'invariant'
import { Button , Chip, FormControlLabel, RadioGroup, Radio, Typography, Slide } from '@material-ui/core'
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import uniqueSampler from 'array-unique-sampler/index.js'
import LeaderboardAvatars from './LeaderboardAvatars'
import StatusBar from './StatusBar'
import { makeStyles } from '@material-ui/core/styles';

function shuffle(array) {
  return [].concat(array).sort(() => Math.random() - 0.5);
}

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '0.25rem'
  }
}));

const randomPeople = [
  'Alphonse Clifford',
  'Ammie Beckstead',
  'Bell Person',
  'Christian Clampitt',
  'Darwin Sprow',
  'Duane Corbeil',
  'Joycelyn Grube',
  'Luke Grounds',
  'Temple Gerrish',
  'Veronique Marker',
]

export default function Leaderboard({ unit }) {
  const availableAvatars = shuffle(LeaderboardAvatars)
  let avatarCursor = 0
  const classes = useStyles()
  const router = useRouter()

  return (
    <Screen>
      <StatusBar title={unit} />

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          flexGrow: 1
        }}
      >
        {shuffle(randomPeople).slice(5).map(name => {
          const avatar = availableAvatars[avatarCursor++]

          if (avatarCursor >= availableAvatars.length) {
            avatarCursor = 0
          }

          return (
            <Card
              key={name}
              style={{ marginBottom: '1rem' }}
            >
              <CardHeader
                classes={{ root: classes.root }}
                title={name}
                avatar={avatar({ style: { width: 65, height: 65 }})}
              />
            </Card>
          )
        })}

        <Button onClick={() => router.navigate('home')}>Back</Button>
      </div>
    </Screen>
  )
}